<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-album
            :profil="profil"
        />

        <!-- Main -->
        <main>
            <div class="albumMainBody">

                <div class="albumPages">
                    <div class="albumPage --first"></div>
                    <div class="albumPage --second"></div>
                    <div class="albumPage --third"></div>
                    <div class="albumPage --fourth"></div>
                </div>    

                <button @click="$router.push({ name: 'profil' })" class="sideMenu__close"><span class="icon"></span></button>
                <div class="albumList__separator"></div>

                <!-- Videosekcia -->
                <div class="albumListing__wrap">

                    <!-- 1. strana -->
                    <div class="albumList__half --first">
                        <!-- Header -->
                        <div class="albumList__heading mb-3 d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">Kravička TV <span class="icon --questionMark" @click="$bvModal.show('modalAlbumAnatomia')"></span></h2>
                        </div>

                        <!-- Videosekcia box -->
                        <div v-if="album.videosekcia" class="albumListing__list --videosekcia">
                            <div v-if="index >= startIndex && index <= (endIndex - 6)" 
                                 v-for="(video, index) in album.videosekcia" 
                                 class="albumListing__item" @click="playVideo(video, index)">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'http://img.youtube.com/vi/' + video.album_videosekcia_video + '/maxresdefault.jpg'" alt="" class="img-fluid" >
                                    <div class="buttonWrapper">
                                        <span class="btn --primary"><span class="icon --videoPlay"></span></span>
                                        <span class="duration">{{ video.album_videosekcia_dlzka }}</span>
                                    </div>
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <p class="albumListing__name mb-0">{{ video.album_videosekcia_nadpis }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2. strana -->
                    <div v-if="album.videosekcia" class="albumList__half --second">
                        <!-- Videosekcia box -->
                        <div class="albumListing__list --videosekcia">
                            <div v-if="index >= (startIndex + 6) && index <= endIndex" 
                                 v-for="(video, index) in album.videosekcia" 
                                 class="albumListing__item" @click="playVideo(video, index)">

                                <!-- Image -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'http://img.youtube.com/vi/' + video.album_videosekcia_video + '/maxresdefault.jpg'" alt="" class="img-fluid" >
                                    <div class="buttonWrapper">
                                        <span class="btn --primary"><span class="icon --videoPlay"></span></span>
                                        <span class="duration">{{ video.album_videosekcia_dlzka }}</span>
                                    </div>
                                </div>

                                <!-- Názov -->
                                <div class="albumListing__descriptionWrap">
                                    <p class="albumListing__name mb-0">{{ video.album_videosekcia_nadpis }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Paginácia -->
                <div v-if="prevPage != 0" @click="changePage(currentPage - 1)" class="albumListing__nav --prev">
                    <span class="icon --prev"></span>Predchádzajúca strana
                </div>
                <div v-if="nextPage != 0" @click="changePage(currentPage + 1)" class="albumListing__nav --next">
                    Ďalšia strana<span class="icon --next"></span>
                </div>

            </div>
        </main>

        <!-- Modal -->
        <b-modal id="modalAlbumAnatomia" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumAnatomiaTitle" aria-hidden="true" ref="modalAlbumAnatomia">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumAnatomia')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body" style="padding:0">
                <div class="text-center">

                    <h2 class="text-center">Nápoveda</h2>
                    <p class="text-18">Tvoj nový online "televízny" kanál plný kravičiek je tu. Spoznaj svet kravičiek a nauč sa, ako žijú a ako sa o ne farmári na farmách starajú.</p>
                    
                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->


        <!-- Modal -->
        <b-modal id="modalAlbumVideo" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumVideoTitle" aria-hidden="true" ref="modalAlbumVideo">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumVideo')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body o-modalInfo" style="padding:0">
                <div class="m-modalLostPassword__content text-center">

                    <!--<h2 class="m-modalWinningPexeso__name text-center">{{ modal_video_nadpis }}</h2>-->
                    <div class="videoWrapper" style="position:relative; padding-bottom:56.25%; padding-top:25px; height:0">
                        <iframe width="420" height="315" :src="'https://www.youtube.com/embed/' + modal_video"  frameborder="0" allowfullscreen style="position:absolute; top:0; left:0; width:100%; height:100%">
                        </iframe>
                    </div>

                    <!--<div class="text-center">
                        <button @click="$bvModal.hide('modalAlbumVideo')" class="btn --primary">Zatvoriť</button>
                    </div>-->

                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuAlbum    from '../partials/MenuAlbum.vue'
    export default {
        components: {
            HeaderObchod,
            MenuAlbum
        },
        props: [
            'profil',
            'album',
            'error'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'album')
            this.toggleBodyClass('addClass', '--videosekcia')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }

            //sessionStorage.setItem("album-videosekcia", "refresh")
            this.getAlbumData('videosekcia')
            this.checkPagination()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'album')
            this.toggleBodyClass('removeClass', '--videosekcia')
        },
        updated() {
            if (this.updated == 0) {
                this.getAlbumData('videosekcia')
            }
        },
        data() {
            return {
                countTotal: 0,
                countOwned: 0,
                percOwned: 0,

                prevPage: 0,
                currentPage: 0,
                nextPage: 0,
                startIndex: 0,
                endIndex: 11,

                modal_video: '',
                modal_video_nadpis: '',

                updated: 0,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },


            // mounted
            getAlbumData(typ) {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    if ( typeof(this.album.videosekcia) == 'undefined' || sessionStorage.getItem("album-videosekcia") ) {
                        EventService.getAlbumData(typ)
                            .then(response => {
                                //console.log(response.data.data)
                                sessionStorage.removeItem("album-videosekcia")

                                // progres pre splnené úspechy
                                var items = response.data.data
                                this.countOwned = 0
                                this.countTotal = items.length

                                // emit alternative
                                this.$set(this.album, 'videosekcia', items)
                                this.checkPagination()
                            })
                            .catch(error => {
                                this.responseType = 'warning'
                                this.responseText = error
                            })

                    }
                }
            },

            checkPagination() {
                if (this.countTotal > 12 || (typeof(this.album.videosekcia) != 'undefined' && this.album.videosekcia.length > 12)) {
                    this.nextPage = 1
                }
            },


            // click
            playVideo(video, index) {
                this.modal_video        = video.album_videosekcia_video
                this.modal_video_nadpis = video.album_videosekcia_nadpis
                this.$bvModal.show('modalAlbumVideo')
            },

            changePage(x) {
                // draw current page
                this.startIndex = 0 + (12 * x)
                this.endIndex   = this.startIndex + 11

                // set pages
                this.nextPage    = 0
                this.prevPage    = x
                this.currentPage = x
                if ( this.endIndex < (this.countTotal - 1) || (typeof(this.album.videosekcia) != 'undefined' && this.endIndex < (this.album.videosekcia.length - 1)) ) {
                    this.nextPage = 1
                }

                //console.log(x + ': ' + this.startIndex + '-' + this.endIndex)
                //console.log(this.nextPage + ': ' + this.endIndex + '>' +this.countTotal)
            },
        }
    }
</script>